/**
 * 链接下载，不同链接视频对应的值
 */
export const VIDEO_LINK_SOURCE_YOUTUBE = 3;
export const VIDEO_LINK_SOURCE_GOOGLE = 6;
export const VIDEO_LINK_SOURCE_TIKTOK = 8;

export const VIDEO_LINK_SOURCE_TWITTER = 10;
export const VIDEO_LINK_SOURCE_INSTAGRAM = 12;

//人机验证 用户有感
export const CLOUDFLARE_SITEKEY = process.env.VUE_APP_CAPTCHA_MANAGED;
//人机验证 用户无感
export const CLOUDFLARE_SITEKEY_INVISIBLE = process.env.VUE_APP_CAPTCHA_INVISIBLE;
// 人机验证类型
export const CLOUDFLARE_STATE_VISIBLE = 4;
export const CLOUDFLARE_STATE_INVISIBLE = 5;

// 下载按钮点击
export const LAST_CLICK_DOWNLOAD_BUTTON = "LAST_CLICK_DOWNLOAD_BUTTON"; //tools下载器页面上一次点击下载按钮时间（有效点击）

// windows-app路径
export const WINDOWS_APP_URL = "https://cdn.viemao.com/client/viemao-windows.exe";

// mac-app路径
export const MACOS_APP_URL = "https://cdn.viemao.com/client/viemao-mac.dmg";
